/**
 * GET `admin/reports/clinics/:id/services` — топ услуг выбранной клиники
 * по убыванию выручки (null serviceId — манипуляции без услуги).
 */

import {apiEnabled, http} from '@services/utils';

import {MOCK_SERVICE_ROWS} from '../mocks';
import {arr, asNum, asObj, asStr, type Raw, toSom} from '../raw.utils';
import type {ReportPeriod, ServiceReportRow} from '../types';

const sleep = (ms: number) => new Promise((r) => setTimeout(r, ms));

export const getClinicServices = async (
  clinicId: string,
  period: ReportPeriod,
): Promise<ServiceReportRow[]> => {
  if (!apiEnabled) {
    await sleep(360);
    return MOCK_SERVICE_ROWS.map((r) => ({...r}));
  }

  const raw = await http<Raw>(`admin/reports/clinics/${encodeURIComponent(clinicId)}/services`, {
    params: {period},
    skipCaseConversion: true,
  });
  return arr(raw.rows).map((v) => {
    const r = asObj(v);
    return {
      serviceId: typeof r.serviceId === 'string' ? r.serviceId : null,
      name: asStr(r.name),
      count: asNum(r.count),
      revenue: toSom(r.revenueTiyin),
    };
  });
};
